import * as statusCode from '../scripts/StatusCode'
import { logout } from '../actions/authentication'
import { isLoginPage } from '../utils'
import * as storage from '../utils/storage'

export async function checkHttpStatus(response) {
    if ((response.status >= 200 && response.status < 300) || response.status === 401) {
        return response
    } else {
        if (!storage.getConfigShowError() && !isLoginPage()) {
            window.location.href = 'error';
        } else {
            var error = new Error(response.statusText)
            error.response = response
            throw error
        }
    }
}

export function parseJSON(response) {
     return response.json()
}

export function errorResponse(response) {
    response.status = statusCode.STATUS_INTERNALSERVERERROR;

    return response;
}

export function ok() {
    return { status: statusCode.STATUS_OK };
}

export function okResponse(response) {
    response.status = statusCode.STATUS_OK;

    return response;
}

export function okResponseList(response) {
    return {
        data: response,
        status: statusCode.STATUS_OK
    }
}

export function notFoundResponse(response) {
    response.status = statusCode.STATUS_NOTFOUND;

    return response;
}

export function objectToQueryString(obj) {
    return Object.keys(obj).map(key => key + '=' + obj[key]).join('&');
}

export function expiredToken(response) {
    if (response.status === 401) {
        logout(true);
    }

    return response;
}